import { Typography } from '@mui/material';
import React from 'react';
import { DpContainer } from '@/components/blocks/DpContainer';

export const DpTitleMobile: React.FC<{ children: string; lower: boolean }> = ({
	children,
	lower,
}) => (
	<DpContainer withoutmargin sx={{ marginBottom: { xs: '10px', sm: '10px' } }}>
		<Typography
			variant="h1"
			sx={{
				color: '#929292',
				fontSize: { xs: '13px', sm: '13px' },
				fontWeight: '800',
				textTransform: !lower ? 'uppercase' : '',
			}}
		>
			{children}
		</Typography>
	</DpContainer>
);
